import styled from 'styled-components/native'

export const ViewAcordionContainer = styled.View`
  width: 98%;
  margin-top: 20px;
  align-self: flex-end;
`
